import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EDomain } from '../base/types';
import {
  ISavePersonalizationDomainStatsPayload,
  ISavePersonalizationLEDStatPayload,
  ISavePersonalizationWorkoutStatsPayload,
} from './types';

export const statePropName = 'personalization';

const personalizationSlice = createSlice({
  name: statePropName,
  initialState: {},
  reducers: {
    savePersonalizationDomainStat: {
      reducer(state, action: PayloadAction<ISavePersonalizationDomainStatsPayload>) {},
      prepare(domain: EDomain, stat: number, userId?: number) {
        return { payload: { domain, stat, userId } };
      },
    },
    savePersonalizationWorkoutStat: {
      reducer(state, action: PayloadAction<ISavePersonalizationWorkoutStatsPayload>) {},
      prepare(workoutId: number, workoutEnabled: boolean, disableImpairment?: boolean, userId?: number) {
        return { payload: { workoutId, workoutEnabled, disableImpairment, userId } };
      },
    },
    savePersonalizationLEDStat: {
      reducer(state, action: PayloadAction<ISavePersonalizationLEDStatPayload>) {},
      prepare(stat: boolean, userId?: number) {
        return { payload: { stat, userId } };
      },
    },
    savePersonalizationTrainingIntensityStat(state, action: PayloadAction<number>) {},
    saveColourblindnessStat: {
      reducer(state, action: PayloadAction<ISavePersonalizationLEDStatPayload>) {},
      prepare(stat: boolean, userId?: number) {
        return { payload: { stat, userId } };
      },
    },
    saveDyscalculiaStat: {
      reducer(state, action: PayloadAction<ISavePersonalizationLEDStatPayload>) {},
      prepare(stat: boolean, userId?: number) {
        return { payload: { stat, userId } };
      },
    },
    initUser(state, action: PayloadAction<number>) {},
  },
});

export const PersonalizationActions = personalizationSlice.actions;
export default personalizationSlice.reducer;
